export const adap_producto_carrito_lateral = ({producto}) => {


    let obj = {
        nombre: producto.nombre,
        id: producto.id,
        cantidad: 1,
        img: producto.img,
        valor: producto.valor,
        valorAntes: producto.valorAntes ? producto.valorAntes : 0,
        idProducto: producto.id,
        artesano: producto.artesano,
        numMaximo: 10
    }

    return obj

}